const axios = require("axios");
import util from "@/util";
import { Message } from 'element-ui';

export default {
    /**
     * 取得当前登录用户的token
     */
    getLoginUserToken() {
        let loginUser = util.getFromLocalStorage("loginUser");
        if (loginUser) {
            return loginUser.token;
        } else {
            return "";
        }
    },

    /**
     * 查询渠道集合
     * 
     * @returns 
     */
    async loadAvailableChannels() {
        let resData = (
            await axios.post(
                `${util.getBackendApiBase()}/api/admin/v1/channel/getList`,
                {},
                {
                    headers: {
                        token: this.getLoginUserToken(),
                    },
                }
            )
        ).data;
        if (resData.code > 0) {
            Message({
                message: resData.message,
                type: "error",
            });
            return;
        }

        let availableChannels = [];

        for (let e of resData.data.channels) {
            availableChannels.push({
                id: e.id,
                name: e.name,
            });
        }

        return availableChannels;
    },

     /**
     * 查询分区集合
     * 
     * @returns 
     */
     async loadAvailableZones() {
        let resData = (
            await axios.post(
                `${util.getBackendApiBase()}/api/admin/v1/zone/getList`,
                {},
                {
                    headers: {
                        token: this.getLoginUserToken(),
                    },
                }
            )
        ).data;
        if (resData.code > 0) {
            Message({
                message: resData.message,
                type: "error",
            });
            return;
        }

        let availableZones = [];

        for (let e of resData.data.zones) {
            availableZones.push({
                id: e.id,
                name: e.name,
            });
        }

        return availableZones;
    },

    /**
     * 查询语言集合
     */
    async loadAvailableLanguages() {
        var resData = (
            await axios.post(
                `${util.getBackendApiBase()}/api/admin/v1/language/getList`,
                {},
                {
                    headers: {
                        token: this.getLoginUserToken(),
                    },
                }
            )
        ).data;
        if (resData.code > 0) {
            Message({
                message: resData.message,
                type: "error",
            });
            return;
        }

        let availableLanguages = [];

        if (resData.data.languageList) {
            for (let l of resData.data.languageList) {
                availableLanguages.push(l);
            }
        }

        return availableLanguages;
    },

     /**
     * 查询角色集合
     */
     async loadRoles() {
        return [
            {
              value: 'normal',
              label: "运营",
            },
            {
              value: 'customerService',
              label: "客服",
            },
            {
                value: 'administrator',
                label: "管理员",
            }
          ];
    },

      /**
     * 查询系统设置
     */
     async loadSystemConfig() {
        let entries = {}
        let resData = (
          await axios.post(
            `${util.getBackendApiBase()}/api/admin/v1/systemConfig/get`,
            {},
            {
              headers: {
                token: this.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
            Message({
            message: resData.message,
            type: "error",
          });
          return;
        }

        return resData.data
      },
}